<template>
  <tr>
    <td>
      <div
        class="team_members_avatar"
        v-bind:style="{
          ...(member.photoURL ? { backgroundImage: `url(${member.photoURL})` } : {})
        }"
      >
        {{!member.photoURL && member.name ? String(member.name).substring(0,1)  : ''}}
        {{!member.photoURL && member.inviteEmail ? String(member.inviteEmail).substring(0,1)  : ''}}
      </div>
    </td>
    <td v-if="member.type === 'invite'" class="team_members_invite">
      <div>
        <div>{{ member.inviteEmail }}</div>
        <div class="team_members_label" v-html="getLabel"></div>
      </div>
    </td>
    <td v-else>
      <div class="team_members_name">
        <div>{{ member.name }}</div>
        <div class="team_members_label" v-html="getLabel"></div>
      </div>
      <div class="team_members_email">
        {{ member.email }}
      </div>
    </td>

    <td>
      <div class="retros_submenu" v-if="showSubmenu">
        <div class="retros_submenu_dots">...</div>
        <div class="submenu">
          <template v-if="isInviteRow">
            <button @click="() => resendInvite(member.id)">
              Resend Invitation
            </button>
            <button class="red" @click="() => cancelInvite(member.id)">
              Cancel Invitation
            </button>
          </template>

          <template v-if="isAdminRow">
            <button
              v-if="isOwner"
              @click="
                () => {
                  removeAdminRight(member.id);
                }
              "
            >
              Remove Admin Rights
            </button>
            <button v-if="isOwner" class="red" @click="() => removeFromTeam(member.id)">Remove from team</button>
          </template>

          <template v-if="isUserRow">
            <button v-if="isOwner" @click="() => makeAdmin(member.id)">Make Admin</button>
            <button class="red" @click="() => removeFromTeam(member.id)">Remove from team</button>
          </template>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex';
import db from '../../firebase-config';
import * as firebase from 'firebase';

export default {
  props: ['member'],
  data() {
    return {
      userLogoSrc: ''
    };
  },
  computed: {
    ...mapState(['currentWorkspace', 'currentUser', 'isAdmin', 'isOwner']),
    showSubmenu(){
      return (this.isOwner && this.isUserRow)
          || (this.isOwner && this.isAdminRow && !this.isOwnerRow)
          || (this.isAdmin && this.isUserRow)
          || (this.isAdmin && this.isInviteRow)

    },
    getLabel() {
      if (this.member.type === 'invite') return '<span>invited</span>';
      if (this.isOwnerRow) return '<span>owner</span>';
      if (this.isAdminRow) return '<span>admin</span>';
      return '';
    },
    isAdminRow() {
      return this.currentWorkspace.admins.includes(this.member.id);
    },
    isUserRow() {
      return this.currentWorkspace.users.includes(this.member.id);
    },
    isOwnerRow() {
      return this.member.id === this.currentWorkspace.payer;
    },
    isInviteRow() {
      return this.member.type === 'invite';
    },
  },
  methods: {
    resendInvite(id) {
      db.collection('invites')
        .doc(id)
        .update({
          resend: firebase.firestore.FieldValue.increment(1)
        })
        .then(() => {
          this.$toasted.show('Invite successfully sent', { type: 'success' });
        });
    },
    cancelInvite(id) {
      db.collection('invites')
        .doc(id)
        .delete()
        .then(() => {
          db.collection('workspaces')
            .doc(this.currentWorkspace.id)
            .update({
              invites: firebase.firestore.FieldValue.arrayRemove(id)
            })
            .then(() => {
              this.$store.dispatch('action_updateCurrentWorkspace');
              this.$toasted.show('Invite successfully canceled', { type: 'success' });
            });
        });
    },
    removeAdminRight(id) {
      db.collection('workspaces')
        .doc(this.currentWorkspace.id)
        .update({
          users: firebase.firestore.FieldValue.arrayUnion(id),
          admins: firebase.firestore.FieldValue.arrayRemove(id)
        })
        .then(() => {
          db.collection('usersInfo')
            .doc(id)
            .update({
              userWorkspaces: firebase.firestore.FieldValue.arrayUnion(this.currentWorkspace.id),
              adminWorkspaces: firebase.firestore.FieldValue.arrayRemove(this.currentWorkspace.id)
            })
            .then(() => {
              this.$toasted.show('Admin Rights successfully removed', { type: 'success' });
            });
        });
    },
    makeAdmin(id) {
      db.collection('workspaces')
        .doc(this.currentWorkspace.id)
        .update({
          users: firebase.firestore.FieldValue.arrayRemove(id),
          admins: firebase.firestore.FieldValue.arrayUnion(id)
        })
        .then(() => {
          db.collection('usersInfo').doc(id)
            .update({
              userWorkspaces: firebase.firestore.FieldValue.arrayRemove(this.currentWorkspace.id),
              adminWorkspaces: firebase.firestore.FieldValue.arrayUnion(this.currentWorkspace.id)
            })
            .then(() => {
              this.$toasted.show('Admin Rights successfully added', { type: 'success' });
            });
        });
    },
    removeFromTeam(id) {
      db.collection('usersInfo')
        .doc(id)
        .update({
          userWorkspaces: firebase.firestore.FieldValue.arrayRemove(this.currentWorkspace.id),
          adminWorkspaces: firebase.firestore.FieldValue.arrayRemove(this.currentWorkspace.id),
          allWorkspaces: firebase.firestore.FieldValue.arrayRemove(this.currentWorkspace.id)
        })
        .then(() => {
          db.collection('workspaces')
            .doc(this.currentWorkspace.id)
            .update({
              users: firebase.firestore.FieldValue.arrayRemove(id),
              admins: firebase.firestore.FieldValue.arrayRemove(id)
            })
            .then(() => {
              this.$toasted.show('User successfully removed', { type: 'success' });
            });
        });
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
